<template>
  <content-dialog
    v-model="paymentReminderDialog"
    fullscreen-mobile
    width="600px"
    title="Send Payment Reminder"
    no-backdrop-dismiss
    :tags="[helpCodes.invoices]"
    @hide="reset"
  >
    <q-list>
      <sticky-header>
        Recipient
      </sticky-header>

      <q-list separator>
        <EditableReminderList
          :reminders="reminders"
          :email-suggestions="$store.getters['clientSuggestionLoader/getEmails'](client.id)"
          :phone-suggestions="$store.getters['clientSuggestionLoader/getPhones'](client.id)"
          :default-email="baseSelectAppropriateClientDetail('EMAIL', client)"
          :default-phone="baseSelectAppropriateClientDetail('SMS', client)"
          real-time
          hide-row-title
          email-prefill-hint="Email has been prefilled from client profile"
          phone-prefill-hint="Mobile has been prefilled from client profile"
          add-label="Add Details"
          @add="addClientReminder"
          @remove="removeClientReminder"
          @email-focus="$store.dispatch('clientSuggestionLoader/loadEmails', client.id)"
          @phone-focus="$store.dispatch('clientSuggestionLoader/loadPhones', client.id)"
        >
          <template #model>
            <client-item
              :client="client"
              dense
              without-email
              without-address
            />
          </template>
        </EditableReminderList>
      </q-list>

      <template v-if="willSendSMS">
        <q-card-section>
          <SmsChargeWarning />
        </q-card-section>

        <SandboxSmsNotice v-if="isDevelopment" class="q-mx-sm" />
      </template>
    </q-list>

    <template #bottom>
      <q-toolbar>
        <q-space />
        <q-btn
          v-close-popup
          flat
          color="blue-grey"
          label="Cancel"
        />
        <q-btn
          :disable="reminders.length < 1"
          label="Send Reminder"
          color="green"
          @click="sendNotification"
        />
      </q-toolbar>
    </template>
  </content-dialog>
</template>

<script>
/*
  Send a payment reminder notification for an invoice
 */
import EditableReminderList from 'components/partials/communications/reminders/EditableReminderList'
import SandboxSmsNotice from 'components/partials/sandbox/SandboxSmsNotice'
import SmsChargeWarning from 'components/partials/communications/SmsChargeWarning'
import fillClientDetailsMixin from 'components/app/calendar/partials/mixins/fillClientDetailsMixin'
import { createReminder, expandReminderTypes } from 'components/partials/communications/communicationMixin'

export default {
  components: {
    EditableReminderList, SandboxSmsNotice, SmsChargeWarning
  },
  mixins: [fillClientDetailsMixin],
  props: {
    id: {
      type: Number,
      required: true
    },
    client: {
      type: Object,
      required: true
    }
  },
  emits: ['sent'],
  data () {
    return {
      isDevelopment: !!process.env.SANDBOX,
      paymentReminderDialog: false,
      reminders: [],
      errors: {}
    }
  },
  computed: {
    statusSettings () {
      return this.baseStatusSettings(this.status)
    },
    willSendSMS () {
      return this.reminders.filter(item => item.type === 'SMS').length > 0
    },
    willSendEmail () {
      return this.reminders.filter(item => item.type === 'EMAIL').length > 0
    }
  },
  methods: {
    open () {
      this.addClientReminder()
      this.paymentReminderDialog = true
    },
    reset () {
      this.reminders = []
      this.errors = {}
    },
    addClientReminder () {
      // A BOTH preference becomes one reminder per channel (EMAIL + SMS).
      for (const type of expandReminderTypes(this.client.default_communication_method)) {
        this.reminders.push(createReminder({
          client_id: this.client.id,
          type,
          key: 'client'
        }))
      }
    },
    removeClientReminder () {
      this.reminders = []
    },
    async sendNotification () {
      this.$loading.show({ message: 'Sending reminder...' })
      this.errors = {}
      const { status, errors } = await this.$post('v1/invoice/payment/notify', {
        id: this.id,
        reminders: this.reminders
      })
      this.$loading.hide()
      if (status === 'success') {
        this.$q.notify({
          color: 'green',
          message: 'Payment reminder successfully sent'
        })
        this.paymentReminderDialog = false
        this.$emit('sent')
      }
      else {
        this.errors = errors
        this.$nextTick(() => { this.scrollToFirstError(this.$el) })
      }
    }
  }
}
</script>
